import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  FormControl,
  ControlLabel,
  Table,
  FormGroup,
  Grid,
  Modal,
} from "react-bootstrap";
import Select from "react-select";
import Card from "components/Card/Card";
import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import { getRiderDetail } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import {
  getPurchaseRequestById,
  createPurchaseRequest,
} from "api/purchaseRequest/purchaseRequest";
import moment from "moment";
import { searchMedicationForWID } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import { AddWarehouseInventoryDispatchAPI } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import Swal from "sweetalert2";
import { getAllStoresByCountryCode } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";

const AddWarehouseInventoryDispatch = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const role = token.role;

  const [rows, setRows] = useState([]);
  const [typingTimeOut, setTypingTimeOut] = useState(null);
  const [medicineSearch, setMedicineSearch] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);
  const [medicationOption, setMedicationOption] = useState([]);
  const [store, setStore] = useState([]);
  const [searchMedicineListData, setSearchMedicineListData] = useState([]);
  const [getPurchaseRequestId, setGetPurchaseRequestId] = useState();
  const [getRiderDetails, setGetRiderDetails] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openInventoryModal, setOpenInventoryModal] = useState(false);
  const [outOfStockRows, setOutOfStockRows] = useState([]);
  const [storeId, setStoreId] = useState(null);
  const [status, setStatus] = useState();

  const [dispatchedDate, setDispatchedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  useEffect(() => {
    fetchAllRider();
    getPurchaseItemsID();
    fetchAllStores();
  }, []);
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        selectedOption: null,
        // description: "",
        qty: "1",
      },
    ]);
  };
  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setStoreOptions(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  const fetchAllRider = async () => {
    try {
      const response = await getRiderDetail(obj);
      const riders = response.data.data.map((riders) => {
        return {
          value: riders.id,
          label: riders.name,
        };
      });
      setGetRiderDetails(riders || []);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };
  const getPurchaseItemsID = () => {
    const id = window.location.pathname.split(
      "add-warehouse-inventory-dispatch/"
    )[1];
    if (!id) {
      console.log("No purchase request ID found in URL");
      setRows([]);
      setGetPurchaseRequestId(null);
      return;
    }
    getPurchaseRequestById(obj, id).then((res) => {
      const data = res.data;
      setGetPurchaseRequestId(data.id);
      setStore({ value: data.store.id, label: data.store.name });
      if (data.request_items.length > 0) {
        const mappedRows = data.request_items.map((item) => ({
          selectedOption: {
            value: item.id,
            label: item.name,
          },
          qty: item.quantity,
          availableStock:
            item.total_quantity - item.total_allocated < 0
              ? 0
              : item.total_quantity - item.total_allocated,
        }));
        setStoreId(data.store_id);
        setStatus(data.status);
        setRows(mappedRows);
      } else {
        setRows([]);
      }
    });
  };
  const handleInputChange = (inputValue) => {
    const val = inputValue;
    setMedicineSearch(val);

    if (typingTimeOut) {
      clearTimeout(typingTimeOut);
    }
    if (val.trim() !== "" && val.length > 2) {
      setTypingTimeOut(
        setTimeout(function () {
          sendToParent(medicineSearch);
        }, 500)
      );
    } else {
      setMedicationOption([]);
      setSearchMedicineListData([]);
    }
  };

  const sendToParent = async (val) => {
    const res = await searchMedicationForWID(val, obj);

    const medicationOption = res.data.data.map((item) => {
      return {
        value: item.id,
        label: item.title,
      };
    });
    setMedicationOption(medicationOption);
    setSearchMedicineListData(res.data.data);
  };

  const handleSelectChange = (selectedOption, index) => {
    const updatedRows = [...rows];
    updatedRows[index].selectedOption = selectedOption;
    setRows(updatedRows);
  };

  const handleDispatchedDate = (value) => {
    const selectedDate = moment(value).format("YYYY-MM-DD");
    setDispatchedDate(selectedDate);
  };

  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }
  };

  const handleQtyChange = (e, index) => {
    const updatedRows = [...rows];
    const value = parseInt(e.target.value, 10) || 1;
    updatedRows[index].qty = value;
    setRows(updatedRows);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const onSubmit = async () => {
    let errors = [];

    if (rows.length === 0) {
      errors.push("Please add at least one medication.");
    }
    if (!dispatchedDate) {
      errors.push("Please select a dispatched date.");
    }

    const outOfStockItems = rows.filter(
      (row) => Number(row.qty) > Number(row.availableStock || 0)
    );
    console.log(outOfStockItems, "outOfStockItems");

    if (outOfStockItems.length > 0) {
      setOutOfStockRows(outOfStockItems);
      setOpenInventoryModal(true);
      return;
    }

    if (errors.length > 0) {
      errors.forEach((msg) => {
        _notificationSystem.current.addNotification({
          message: msg,
          level: "error",
        });
      });
      return;
    }
    Swal.fire({
      width: "475px",
      title:
        "<div style='font-size:26px;font-weight: 100;'>Are You Want To Dispatch This Order</div>",
      icon: "warning",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        moveToDispatchItems();
      }
    });
  };
  const moveToDispatchItems = async () => {
    const data = {
      dispatch_date: dispatchedDate,
      dispatch_by: token.id,
      medications: rows.map((row) => ({
        medication_id: row.selectedOption && row.selectedOption.value,
        quantity: row.qty,
      })),
      purchase_request_id: getPurchaseRequestId,
      store_id: store ? store.value : null,
    };
    const res = await AddWarehouseInventoryDispatchAPI(data, obj);
    if (!!res.data.success) {
      _notificationSystem.current.addNotification({
        message: "Warehouse Inventory Dispatch submitted successfully!",
        level: "success",
      });

      setRows([]);
      setDispatchedDate(moment().format("YYYY-MM-DD"));
      setMedicineSearch(null);
      setMedicationOption([]);
      setSearchMedicineListData([]);

      setTimeout(() => {
        props.history.push("/admin/warehouse-inventory-dispatch");
      }, 2000);
    } else {
      _notificationSystem.current.addNotification({
        message: "Failed to submit Warehouse Inventory Dispatch.",
        level: "error",
      });
    }
  };

  const disablePastDt = (current) => {
    const yesterday = moment().subtract(1, "day");
    return current.isAfter(yesterday);
  };
  return (
    <div className="add-warehouse-inventory-dispatch">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Col md={8}>
          <Card
            content={
              <div
                style={{
                  marginBottom: "40px",
                  padding: "0 20px",
                }}
              >
                <Col md={12}>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Store</ControlLabel>
                          <Select
                            options={storeOptions}
                            onChange={(selectedOption) => {
                              setStore(selectedOption);
                            }}
                            placeholder="Select Store"
                            value={store}
                            isDisabled={true}
                          />
                          {/* {requestDateError} */}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Dispatched Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            defaultValue={new Date()}
                            isValidDate={disablePastDt}
                            closeOnSelect={true}
                            value={dispatchedDate}
                            onChange={handleDispatchedDate}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Medicine Name</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Available Stock</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Quantity</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  No medication added
                                </td>
                              </tr>
                            ) : (
                              rows.map((row, index) => (
                                <tr key={index}>
                                  <td style={{ width: "30%" }}>
                                    <Select
                                      isDisabled={status === 3 || status === 4}
                                      placeholder="Search medicine"
                                      value={
                                        row.selectedOption &&
                                        row.selectedOption.label &&
                                        row.selectedOption.value
                                          ? row.selectedOption
                                          : null
                                      }
                                      onChange={(selected) =>
                                        handleSelectChange(selected, index)
                                      }
                                      onInputChange={(inputValue) =>
                                        handleInputChange(inputValue)
                                      }
                                      options={medicationOption}
                                      isClearable
                                      isSearchable
                                      noOptionsMessage={() => "No results"}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <FormControl
                                      name="availableQuantity"
                                      isDisabled
                                      value={row.availableStock}
                                      type="text"
                                      placeholder="Available Stock"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <FormControl
                                      disabled={status === 3 || status === 4}
                                      name="qty"
                                      value={
                                        row.selectedOption
                                          ? Math.max(0, row.qty)
                                          : ""
                                      }
                                      type="number"
                                      min="1"
                                      placeholder="Enter Quantity"
                                      onBlur={(e) => handleQtyBlur(e, index)}
                                      onChange={(e) =>
                                        handleQtyChange(e, index)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <a
                                      style={{
                                        pointerEvents:
                                          status === 3 || status === 4
                                            ? "none"
                                            : "auto",
                                        color:
                                          status === 3 || status === 4
                                            ? "gray"
                                            : "blue",
                                      }}
                                      href="javascript:void(0)"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      X
                                    </a>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Row>
                  <Col sm={12}>
                    <Button
                      style={{ marginBottom: "15px" }}
                      onClick={onSubmit}
                      className="fl_btn_add_order btn-fill btn btn-default"
                      fill
                    >
                      Submit
                    </Button>{" "}
                  </Col>
                </Row>
                <>
                  <Modal
                    show={openInventoryModal}
                    onHide={() => setOpenInventoryModal(false)}
                    bsSize="large"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Medicine Out Of Stock</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {" "}
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Medicine Name</th>
                            <th>Ordered Qty</th>
                            <th>Available Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {outOfStockRows &&
                            outOfStockRows.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  {row.selectedOption &&
                                    row.selectedOption.label}
                                </td>
                                <td>{row.qty}</td>
                                <td>
                                  {row.availableStock < 0
                                    ? 0
                                    : row.availableStock}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        className="btn-fill btn btn-info"
                        onClick={() => setOpenInventoryModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              </div>
            }
          />
        </Col>
      </Grid>
    </div>
  );
};
export default AddWarehouseInventoryDispatch;
